<template>
	<BaseLayout :vertically-centered="true" :footer-full="true">
		<main class="container text-align-center">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md col-6-lg col-offset-3-lg">
					<h1 class="heading-1 mb-100 mb-200-md">Page Not Found</h1>
					<div class="module">
						<div class="module-section">
							<p>
								Oops. Somehow you are trying to view a page that doesn&rsquo;t exist. This error has
								been logged and we&rsquo;ll look into it ASAP.
							</p>
						</div>
						<div class="module-section">
							<BaseLink class="button button-outline" :link="returnToHomeLink" />
						</div>
					</div>
				</div>
			</div>
		</main>
	</BaseLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Link } from 'types/layout';
import { useAppStore } from '@stores/app';
import { useHead } from '@unhead/vue';

const appStore = useAppStore();

const returnToHomeLink = computed((): Link => {
	return {
		router: appStore.isAuthenticated ? 'account-overview' : 'home',
		text: 'Back to home'
	};
});

function setup(): void {
	useHead({
		title: 'Not Found',
		meta: [
			{
				name: 'prerender-status-code',
				content: '404'
			}
		],
		script: [`window.prerenderReady = true;`]
	});
}
setup();
</script>
